import { render } from "./HivePhotoSliderBasic.vue?vue&type=template&id=ac50fbc8&scoped=true"
import script from "./HivePhotoSliderBasic.vue?vue&type=script&lang=js"
export * from "./HivePhotoSliderBasic.vue?vue&type=script&lang=js"

import "./HivePhotoSliderBasic.vue?vue&type=style&index=0&id=ac50fbc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ac50fbc8"

export default script